<template>
  <div id="app">
    <headComponents/>
		<div class="body_page">
		  <router-view></router-view>
			<footComponents v-if="routerName!='/home'"/>
		</div>
  </div>
</template>

<script>
import headComponents from './components/headComponents.vue'
import footComponents from './components/footComponents.vue'
export default {
  name: 'App',
  components: {
    headComponents,
		footComponents
  },
	data(){
		return{
			routerName:''
		}
	},
	watch: {
	  $route: function (val) {
	    this.routerName = val.path
	  }  
	},
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
	font-size: 14px;
  color: #000;
	min-width: 1200px;
}
.body_page{
    max-height:calc(100vh - 70px);
		overflow: auto;
  }
</style>
